import React, { Component } from 'react';

import {
  LineChart,
  Line,
  BarChart,
  Bar,
  XAxis,
  Tooltip, Legend,
  ResponsiveContainer
} from 'recharts';

class MiniGraph extends Component {

  render() {

    const CustomTooltip1 = ({ active, payload }) => {
      let real = this.props.dataKey2;

      if (active, payload) {
        return (
          <div className="custom-tooltip">
            <p className="label">{payload[0] ? payload[0].dataKey == 'ontimeperformance' ?
              payload[0].payload[real].toLocaleString('fr-CA') + '%' :
              payload[0].payload[real].toLocaleString('fr-CA') : 'ND'}</p>
          </div>
        );
      }
    }

    const CustomTooltip2 = ({ active, payload }) => {
      let planned = this.props.dataKey1;
      let real = this.props.dataKey2;
      if (active, payload) {
        return (
          <div className="custom-tooltip">
            <p className="label">{this.props.name1} : <br />{payload[0] ? payload[0].payload[planned] ? payload[0].payload[planned].toLocaleString('fr-CA') : 'ND' : 'ND'}<br />
              {this.props.name2} : <br />{payload[0] ? payload[0].payload[real] ? payload[0].payload[real].toLocaleString('fr-CA') : 'ND' : 'ND'}<br />
              % {this.props.name1}/{this.props.name2} : <br />{payload[0] ? Math.round(payload[0].payload[real] / payload[0].payload[planned] * 100) : 'ND'} %</p>
          </div>
        );
      }

      return null;
    };

    return (
      <React.Fragment>
        <div className="col-xl-2 col-lg-4 col-md-4 col-6 pb-2">
          <div className="border rounded" style={{ backgroundColor: "white" }}>
            <p className="text-center"><b>{this.props.kpi}</b></p>
            <ResponsiveContainer width="100%" height={300}>
              <LineChart width={150} height={40} data={this.props.data}
                margin={{ left: 30, right: 30, bottom: 10 }}
              >
                <Line dataKey={this.props.dataKey2} fill="#770066" dot={{ r: 2}} stroke="#770066" name={this.props.name2} isAnimationActive={false} />
                {this.props.dataKey1 !== '' ? <Line dataKey={this.props.dataKey1} dot={{ r: 2}} fill="#D3D3D3" stroke="grey" name={this.props.name1} isAnimationActive={false} /> : ''}
                <XAxis dataKey={this.props.xAxisKey} angle={-90} dx={-4} textAnchor="end" interval={0} height={100} />
                <Tooltip
                  content={this.props.dataKey1 !== '' ? <CustomTooltip2 /> : <CustomTooltip1 />}
                />
                <Legend
                  formatter={(value, entry, index) =>
                    <span style={{ color: "black" }} className="text-color-class">{value}</span>
                  }
                />
              </LineChart>
            </ResponsiveContainer>
          </div>
        </div>
      </React.Fragment >
    );
  }
}

export default MiniGraph;